import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const CONTACT_FIELDS = `
  id,
  firstName,
  lastName,
  title,
  email,
  phoneNumber { formatted, value}
  primary
`

const CONTACT_VARIABLES = `
  $firstName: String!
  $lastName: String
  $title: String
  $email: String
  $phoneNumber: String
`;

const CONTACT_ARGUMENTS = `
  firstName: $firstName
  lastName: $lastName
  title: $title
  email: $email
  phoneNumber: $phoneNumber
`;

const CONTACT_FIELDS_AND_ERRORS = `
  contact {
    ${CONTACT_FIELDS}
  }
  ${ERRORS}
`;

export const CONTACTS_WITH_COUNT = gql`
  query (
    $sellerId: ID
    ${WITH_COUNT_VARIABLES}
  ) {
    contactsWithCount(
      sellerId: $sellerId
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${CONTACT_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_CONTACT = gql`
  mutation CreateContact(
    $sellerId: ID!
    $primary: Boolean!
    ${CONTACT_VARIABLES}
  ) {
    createContact(
      sellerId: $sellerId
      primary: $primary
      ${CONTACT_ARGUMENTS}
    ) {
      ${CONTACT_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_CONTACT = gql`
  mutation UpdateContact(
    $id: ID!
    $primary: Boolean
    ${CONTACT_VARIABLES}
  ) {
    updateContact(
      id: $id
      primary: $primary
      ${CONTACT_ARGUMENTS}
    ) {
      ${CONTACT_FIELDS_AND_ERRORS}
    }
  }
`;

export const CONTACT = gql`
  query Contact($id: ID!) {
    conract(id: $id) {
      ${CONTACT_FIELDS}
    }
  }
`;

export const HIDE_CONTACT = gql`
  mutation HideContact($id: ID!) {
    hideContact(id: $id) {
      contact {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_CONTACT = gql`
  mutation UnhideContact($id: ID!) {
    unhideContact(id: $id) {
      contact {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

